module.exports = __webpack_public_path__ + "img/系统头像@3x.2a96668a.png";